import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  // const services = [
  //   { name: 'Արտադրանքի և ծառայությունների սերտիֆիկացում', path: '/product-certification' },
  //   { name: 'Կառավարման համակարգերի սերտիֆիկացում', path: '/management-certification' },
  //   { name: 'Ֆիզիկական անձանց սերտիֆիկացում', path: '/personnel-certification' },
  //   { name: 'Արտադրական կորուստների նորմատավորում', path: '/production-losses' },
  //   { name: 'Լաբորատոր փորձարկումներ', path: '/lab-tests' },
  //   { name: 'Խորհրդատվություն', path: '/consultation' },
  // ];

  return (
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md shadow-sm py-2 transition-all duration-300">
        <div className="container mx-auto px-4 text-gray-800">
          <div className="flex justify-between items-center">
            <Link
                to="/"
                onClick={() => window.scrollTo(0, 0)}
                className="flex items-center"
            >
              <img src="/logo.png" alt="Logo" className="h-20 w-auto" />
            </Link>

            {/* DESKTOP NAV */}
            <nav className="hidden md:flex space-x-8 items-center">
              <Link
                  to="/"
                  className="font-bold hover:text-blue-400 text-gray-700"
                  onClick={() => window.scrollTo(0, 0)}
              >
                Գլխավոր
              </Link>

              {location.pathname === '/' ? (
                  <button
                      onClick={() => scrollToSection('about')}
                      className="font-bold hover:text-blue-400 text-gray-700"
                  >
                    Մեր մասին
                  </button>
              ) : (
                  <Link to="/#about" className="font-bold hover:text-blue-400 text-gray-700">
                    Մեր մասին
                  </Link>
              )}

              <Link
                  to="/services"
                  className="font-bold hover:text-blue-400 text-gray-700"
                  onClick={() => window.scrollTo(0, 0)}
              >
                Ծառայություններ
              </Link>

              {/* PRODUCT CERTIFICATION LINK */}
              <Link
                  to="/product-certification"
                  className="font-bold hover:text-blue-400 text-gray-700"
                  onClick={() => window.scrollTo(0, 0)}
              >
                Հանրմատչելի տեղեկատվություն
              </Link>

              {location.pathname === '/' ? (
                  <button
                      onClick={() => scrollToSection('contact')}
                      className="font-bold hover:text-blue-400 text-gray-700"
                  >
                    Կոնտակտներ
                  </button>
              ) : (
                  <Link to="/#contact" className="font-bold hover:text-blue-400 text-gray-700">
                    Կոնտակտներ
                  </Link>
              )}
            </nav>

            {/* MOBILE BUTTON */}
            <button
                className="md:hidden text-gray-800 p-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              ☰
            </button>
          </div>
        </div>

        {/* MOBILE MENU */}
        {isMenuOpen && (
            <div className="md:hidden bg-white border-t shadow-lg">
              <div className="flex flex-col px-4 py-2">

                <Link
                    to="/"
                    className="py-3 border-b"
                    onClick={() => {
                      setIsMenuOpen(false);
                      window.scrollTo(0, 0);
                    }}
                >
                  Գլխավոր
                </Link>

                {location.pathname === '/' ? (
                    <button
                        onClick={() => scrollToSection('about')}
                        className="py-3 text-left border-b"
                    >
                      Մեր մասին
                    </button>
                ) : (
                    <Link
                        to="/#about"
                        className="py-3 border-b"
                        onClick={() => setIsMenuOpen(false)}
                    >
                      Մեր մասին
                    </Link>
                )}

                <Link
                    to="/product-certification"
                    className="py-3 border-b"
                    onClick={() => {
                      setIsMenuOpen(false);
                      window.scrollTo(0, 0);
                    }}
                >
                  Հանրմատչելի տեղեկատվություն
                </Link>

                {location.pathname === '/' ? (
                    <button
                        onClick={() => scrollToSection('contact')}
                        className="py-3 text-left"
                    >
                      Կոնտակտներ
                    </button>
                ) : (
                    <Link
                        to="/#contact"
                        className="py-3"
                        onClick={() => setIsMenuOpen(false)}
                    >
                      Կոնտակտներ
                    </Link>
                )}

              </div>
            </div>
        )}
      </header>
  );
}